import React from 'react';
import { useLocation } from 'react-router-dom';
import { StyledNavbarContainer, StyledLink } from './style';
import { StyledDiv } from '../../../../Theme/CommonStyled';
import Icon from '../../Icon';
import useWindowSize from '../../../../Utils/useWindowsSize';
import { useTranslation } from 'react-i18next';
import useCreditsStore from '../../../../Store/Credits';

const TABS = [
  { label: 'credits', icon: 'credit', url: '/credits' },
  { label: 'contactUs', icon: 'phone_2', url: '/contactUs' },
  { label: 'purchases', icon: 'shopping_bag', url: '/purchases' },
  { label: 'profile', icon: 'user_1', url: '/profile' }
];

const AppNavbar = () => {
  const location = useLocation();
  const [width] = useWindowSize();
  const { t } = useTranslation();

  const setDataLength = useCreditsStore((state) => state.setDataLength);

  return (
    <StyledNavbarContainer width={width > 440 ? 440 : width} margin="auto">
      {TABS.map((item) => (
        <StyledLink
          onClick={() => {
            setDataLength(10);
          }}
          isActive={location.pathname === item.url}
          key={item.label}
          to={item.url}>
          <Icon name={item.icon} fontSize={14} mb={4} mt={3} />
          <StyledDiv>{t(`navigationBar.${item.label}`)}</StyledDiv>
        </StyledLink>
      ))}
    </StyledNavbarContainer>
  );
};

export default AppNavbar;
